<template>
  <div class="work" v-if="work && work.partials && work.partials.length">
    <PartialsLoader :partials="work.partials" />
    <Footer />
  </div>
</template>

<script>
import PartialsLoader from "@components/PartialsLoader";
import Footer from "@components/global/Footer";

import { mapGetters } from "vuex";

export default {
  components: {
    PartialsLoader,
    Footer
  },
  metaInfo() {
    return {
      title: this.getTitle(),
      titleTemplate: '%s | Dinamo Digitale',
      meta: [
        { name: 'og:title', content: this.getTitle() + ' | Dinamo Digitale'},
        { name: 'twitter:title', content: this.getTitle() + ' | Dinamo Digitale'},
        { name: 'description', content: this.getAbstract()},
        { name: 'og:description', content: this.getAbstract()},
        { name: 'twitter:description', content: this.getAbstract()},
        { name: 'keywords', content: this.getDescription()},
        { name: 'og:type', content: 'website'},
        { name: 'og:url', content: window.location.href},
        { name: 'og:image', content: this.getWorkImage()},
        { name: 'twitter:image', content: this.getWorkImage()},
      ]
    }
  },
  data() {
    return {
      isLogged: false,
      resourceUrl: process.env.VUE_APP_RESOURCES,
      defaultTitle: 'Work',
      defaultDescription: 'Scopri i nostri lavori',
      defaultKeywords: 'consulenza design marketing sviluppo integrazione'
    };
  },
  mounted() {
    this.getWork(this.$route.params.slug);
  },
  methods: {
    getWork(slug) {
      this.$store.dispatch("getWork", slug);
    },
    getTitle() {
      if (this.work && this.work.title) {
        return this.work.title
      }
      return this.defaultTitle
    },
    getAbstract() {
      if (this.work && this.work.abstract) {
        return this.work.abstract
      }
      return this.defaultDescription
    },
    getDescription() {
      if (this.work && this.work.description) {
        return this.work.description
      }
      return this.defaultKeywords
    },
    getWorkImage() {
      if (this.work && this.work.mainImage && this.work.mainImage.file && this.work.mainImage.file.path) {
        return this.resourceUrl + this.work.mainImage.file.path
      } else if (this.work && this.work.mobileImage && this.work.mobileImage.file && this.work.mobileImage.file.path) {
        return this.resourceUrl + this.work.mobileImage.file.path
      }
      return undefined
    }
  },
  computed: {
    ...mapGetters({
      work: "getWork"
    })
  }
};
</script>


<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
/deep/ {
  .main-cell {
    .cell {
      position: relative;
    }
  }
}
.work {
  padding: 64px;
  @include breakpoint(medium down) {
    padding: 0 0 64px;
  }
}
</style>
